import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {HttpModule, Http} from '@angular/http';
import {HttpClientModule} from '@angular/common/http'
import {APP_INITIALIZER,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import '../styles/styles.scss';
import {
  NgModule,
  ApplicationRef
} from '@angular/core';
import {
  removeNgStyles,
  createNewHosts,
  createInputTransfer
} from '@angularclass/hmr';
import {
  RouterModule,
  PreloadAllModules
} from '@angular/router';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

/*
 * Platform and Environment providers/directives/pipes
 */
import {ENV_PROVIDERS} from './environment';
import {ROUTES} from './app.routes';
// App is our top level component
import {AppComponent} from './app.component';
import {APP_RESOLVER_PROVIDERS} from './app.resolver';
import {AppState, InternalStateType} from './app.service';
import {HomeComponent} from './home';
import {AboutComponent} from './about';
import {NoContentComponent} from './no-content';
import {XLargeDirective} from './home/x-large';

import '../styles/styles.scss';
import '../styles/headings.css';
import {TranslateModule, TranslateLoader, TranslateStaticLoader} from "ng2-translate";
import {ShareModule} from "./share/share.module";
import {LoginComponent} from "./login/login.component";
import {RegisterComponent} from "./register/register.component";
import {CompanyProfileComponent} from "./component/company-profile/company-profile.component";
import {MapComponent} from "./component/map/map.component";
import {AgmCoreModule} from "../../node_modules/@agm/core/core.module";
import {GoogleMapsAPIWrapper} from "../../node_modules/@agm/core/services/google-maps-api-wrapper";
import {InfoBoxContentComponent} from "./component/map/info-box-content.component";
import {ServiceListComponent} from "./component/service-list/service-list.component";
import {SharingFormComponent} from "./component/shared/sharing-form/sharing-form.component";
import {PersistenceModule} from 'angular-persistence';
import {DialogFormComponent} from "./component/shared/dialog-form/dialog-form.component";
import {ResetPasswordComponent} from "./reset-password/reset-password.component";
import {CategoryService} from "./services/category/category.service";
import {CategoryServiceListComponent} from "./component/category-service-list/category-service-list.component";
import {SelectDateDialog} from "./component/shared/select-date-dialog/select-date-dialog.component";
import {SelectDateDialogV2} from "./component/shared/select-date-dialog/select-date-dialog-v2.component";

import {ServiceCardsComponent} from "./component/service-cards/service-cards.component";
import {CategoryServiceCardsComponent} from "./component/category-service-cards/category-service-cards.component";
import {Ng2PageScrollModule} from 'ng2-page-scroll';
import {CompanyListComponent} from "./component/company-list/company-list.component";
import {FileUploader, FileUploadModule} from 'ng2-file-upload';
import {FileUploadComponent} from "./component/shared/file-upload/file-upload.component";
import {ServantListComponent} from "./component/servant-list/servant-list.component";
import {ServantListHomeComponent} from "./servantListHome/servantListHome.component";
import {AppConfig} from "./services/app.config";
import {XBodyComponent} from "./xBodyComponent/xBody.component";
import {VideoMeetingModule} from "./video-meeting/videoMeeting.module";
import {VideoMeetingComponent} from "./video-meeting/videoMeeting.component";
import {WedomeetVideoComponent} from "./wedomeet-video/wedomeet-video.component";
import {WidgetPageComponent} from "./widget-page/widget-page.component";
import {LoginFormNoPassComponent} from "./component/login-form-nopass/login-form-nopass.component";
import {ComplementaryInformationComponent} from "./component/complementary-information/complementaryInformation.component";
// import {PersonInfoComponent} from "./component/person-info/personInfo.component";
import {CompanyCustomFormComponent} from "./component/company-custom-form/companyCustomForm.component";
import {CompanyCustomFormDialogComponent} from "./component/company-custom-form/companyCustomForm-dialog.component";
import {AuthGuard} from "./services/auth/AuthGuard";
import {CompanyHeaderComponent} from "./component/company-header/company-header.component";
import {ServiceCardsModernComponent} from "./component/service-cards-modern/service-cards-modern.component";
import {CategoryServiceCardsModernComponent} from "./component/category-service-cards-modern/category-service-cards-modern.component";
import {NavbarModernComponent} from "./component/navbar-modern/navbar-modern.component";
import {CompanyFooterComponent} from "./component/company-footer/company-footer.component";
import {ServiceListModernComponent} from "./component/service-list-modern/service-list-modern.component";
import {ServantListModernComponent} from "./component/servant-list-modern/servant-list-modern.component";
import {MarketplaceCompanyListComponent} from "./component/marketplace-company-list/marketplace-company-list.component";
import {WhatsappSupportComponent} from "./component/whatsapp-support/whatsapp-support.component";
import {InvoiceInfoDetailComponent} from "./invoice-info-detail/invoice-info-detail.component";
import {TestServicesComponent} from "./component/test-services/test-services.component";
import {TestReturnUrlComponent} from "./component/test-services/test-return-url.component";
import {BookComponentVueComponent} from "./component/book-component-vue/book-component-vue.component";



//import {MomentTimezoneModule} from 'angular-moment-timezone';

// Application wide providers
const APP_PROVIDERS = [
  ...APP_RESOLVER_PROVIDERS,
  AppState
];

type StoreType = {
  state: InternalStateType,
  restoreInputValues: () => void,
  disposeOldHosts: () => void
};

export function initializeApp(appConfig: AppConfig) {

  return () => appConfig.load();
}

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
export function TranslateStaticLoaderFun(http: Http) {
  return new TranslateStaticLoader(http, '/assets/i18n-14011218n', '.json')
}

@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
    AboutComponent,
    HomeComponent,
    ServantListHomeComponent,
    ServantListComponent,
    // LoginComponent,
    NoContentComponent,
    // RegisterComponent,
    CompanyProfileComponent,
    XLargeDirective,
    InfoBoxContentComponent,
    ServiceListComponent,
    ServiceCardsComponent,
    CompanyListComponent,
    XBodyComponent,
    CategoryServiceCardsComponent,
    CategoryServiceListComponent,
    MapComponent,
    ResetPasswordComponent,
    SelectDateDialog,
    SelectDateDialogV2,
    FileUploadComponent,
    VideoMeetingComponent,
    WedomeetVideoComponent,
    WidgetPageComponent,
    ComplementaryInformationComponent,
    // PersonInfoComponent,
    CompanyCustomFormComponent,
    CompanyCustomFormDialogComponent,
    CompanyHeaderComponent,
    ServiceCardsModernComponent,
    CategoryServiceCardsModernComponent,
    NavbarModernComponent,
    CompanyFooterComponent,
    ServiceListModernComponent,
    ServantListModernComponent,
    MarketplaceCompanyListComponent,
    WhatsappSupportComponent,
    InvoiceInfoDetailComponent,
    TestServicesComponent,
    TestReturnUrlComponent,
    BookComponentVueComponent

  ],
  /**
   * Import Angular's modules.
   */
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    PersistenceModule,
    ShareModule,
    Ng2PageScrollModule,
    FileUploadModule,
    // VideoMeetingModule,

    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD0YlU6AgBhnqeTr9Sl_XbkcULpVsCyErI'
    }),

    RouterModule.forRoot(ROUTES, {
      //useHash: Boolean(history.pushState) === false,
      preloadingStrategy: PreloadAllModules, useHash: true
    }),
    TranslateModule.forRoot({
      provide: TranslateLoader,
      useFactory: TranslateStaticLoaderFun,
      deps: [Http]
    }),
  ],
  /**
   * Expose our Services and Providers into Angular's dependency injection.
   */
  providers: [
    AppConfig,
    AuthGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig], multi: true
    },
    ENV_PROVIDERS,
    APP_PROVIDERS,
    GoogleMapsAPIWrapper

  ],
  entryComponents: [SharingFormComponent, DialogFormComponent, SelectDateDialog, SelectDateDialogV2, FileUploadComponent, CompanyCustomFormDialogComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {

  constructor(public appRef: ApplicationRef,
              public appState: AppState) {
  }

  public hmrOnInit(store: StoreType) {
    if (!store || !store.state) {
      return;
    }
    /**
     * Set state
     */
    this.appState._state = store.state;
    /**
     * Set input values
     */
    if ('restoreInputValues' in store) {
      let restoreInputValues = store.restoreInputValues;
      setTimeout(restoreInputValues);
    }

    this.appRef.tick();
    delete store.state;
    delete store.restoreInputValues;
  }

  public hmrOnDestroy(store: StoreType) {
    const cmpLocation = this.appRef.components.map((cmp) => cmp.location.nativeElement);
    /**
     * Save state
     */
    const state = this.appState._state;
    store.state = state;
    /**
     * Recreate root elements
     */
    store.disposeOldHosts = createNewHosts(cmpLocation);
    /**
     * Save input values
     */
    store.restoreInputValues = createInputTransfer();
    /**
     * Remove styles
     */
    removeNgStyles();
  }

  public hmrAfterDestroy(store: StoreType) {
    /**
     * Display new elements
     */
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/app.module.ts